import { render } from "./UpdateAnnouncement.vue?vue&type=template&id=10514193&scoped=true"
import script from "./UpdateAnnouncement.vue?vue&type=script&lang=js"
export * from "./UpdateAnnouncement.vue?vue&type=script&lang=js"

import "./UpdateAnnouncement.vue?vue&type=style&index=0&id=10514193&lang=scss&scoped=true"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10514193"]])

export default __exports__